<div class="container mt-5 mb-5">
  <div class="row">
    <div class="col-lg-6 text-center mb-5">
      <h2>Página não encontrada</h2>
      <p>Este link está quebrado ou a página foi removida.</p>
      <a routerLink="" class="btn btn-primary">Voltar para o início</a>
    </div>
    <div class="col-lg-6 text-center">
      <img src="assets/page-not-found.jpg" class="img-fluid" />
    </div>
  </div>
</div>
